
import { useAssessmentSession } from './assessment/useAssessmentSession';
import { useAssessmentQuestions } from './assessment/useAssessmentQuestions';
import { useAssessmentSubmission } from './assessment/useAssessmentSubmission';
import { useState, useEffect } from 'react';

export const useAssessmentState = () => {
  // Welcome overlay state
  const [showWelcomeOverlay, setShowWelcomeOverlay] = useState(false);
  
  // Get session state
  const {
    sessionChecked,
    activeUserId,
    currentOrderId,
    initError,
    isInitializing,
    setIsInitializing
  } = useAssessmentSession();

  // Get questions and navigation state
  const {
    questions,
    currentQuestionIndex,
    responses,
    isQuestionVisible,
    direction,
    canEarlySubmit,
    handleOptionSelect,
    handleNext,
    handlePrevious
  } = useAssessmentQuestions(sessionChecked, activeUserId, initError, setIsInitializing);

  // Get submission state
  const {
    isSubmitting,
    isGeneratingReport,
    showSuccessMessage,
    submitError,
    handleSubmit
  } = useAssessmentSubmission(
    questions,
    responses,
    canEarlySubmit,
    activeUserId,
    currentOrderId
  );
  
  // Show welcome overlay when questions are loaded
  useEffect(() => {
    if (questions.length > 0 && currentQuestionIndex === 0 && !isInitializing) {
      const hasSeenWelcomeOverlay = localStorage.getItem('has_seen_assessment_welcome');
      if (!hasSeenWelcomeOverlay) {
        setShowWelcomeOverlay(true);
      }
    }
  }, [questions.length, currentQuestionIndex, isInitializing]);
  
  // Handle closing the welcome overlay
  const handleWelcomeClose = () => {
    setShowWelcomeOverlay(false);
    localStorage.setItem('has_seen_assessment_welcome', 'true');
  };

  return {
    questions,
    currentQuestionIndex,
    responses,
    isSubmitting,
    isGeneratingReport,
    showSuccessMessage,
    submitError,
    isQuestionVisible,
    direction,
    isInitializing,
    initError,
    canEarlySubmit,
    showWelcomeOverlay,
    handleWelcomeClose,
    handleOptionSelect,
    handleNext,
    handlePrevious,
    handleSubmit,
  };
};
